import React, { HTMLProps, PropsWithChildren } from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import { createStyles } from "@material-ui/core"
import clsx from "clsx"

export type HCenterProps = PropsWithChildren<{
  maxWidth?: number
}> & HTMLProps<HTMLDivElement>

const useStyles = makeStyles(() => createStyles({
  root: {
    margin: "auto",
  },
}))

export default function HCenter(props: HCenterProps) {
  const {
    className,
    children,
    maxWidth,
    ...restProps
  } = props

  const classes = useStyles()

  return (
    <div
      className={clsx(className, classes.root)}
      {...restProps}
      style={{ ...restProps.style, maxWidth }}
    >
      {children}
    </div>
  )
}
